import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import qs from 'query-string';

import getEnvConfig from 'utils/config/env';

import { PostsData } from './posts.interface';
import { AnalyticsFiltersProps } from '../../AnalyticsFilters/service/filters.interface';

export const analyticsPostsApi = createApi({
    reducerPath: 'analyticsPosts',
    baseQuery: fetchBaseQuery({
        baseUrl: getEnvConfig().env.API_URL,
        prepareHeaders: headers => {
            const token = localStorage.getItem('accessToken');
            headers.set('Authorization', `Bearer ${token}`);
            return headers;
        },
    }),
    tagTypes: ['AnalyticsPosts'],
    endpoints: builder => ({
        getPosts: builder.query<PostsData, AnalyticsFiltersProps>({
            query: args => {
                const queryArgs = qs.stringify(args, {
                    arrayFormat: 'bracket',
                    skipNull: true,
                });
                return {
                    url: `/statistic/posts/charts?${queryArgs}`,
                    method: 'GET',
                };
            },
            transformResponse: (response: { data: PostsData }) => {
                return response.data;
            },
        }),
    }),
});

export const { useLazyGetPostsQuery } = analyticsPostsApi;
